import { createContext, useContext, useEffect, useState } from 'react';
import * as hlp from 'utils/helpers/gimHelper';

// Створюмо контекст
const ThemeContext = createContext();

// Привязуємо хук useTheme до контексту ThemeContext
export const useTheme = () => useContext(ThemeContext); 

// Компонент - провайдер контексту
export const ThemeProvider = ({children}) => {

    const themeStore = hlp._localGet('theme');
    const initialDarkTheme = themeStore === null ? true : hlp._bool(themeStore);
    const [ darkTheme, setDarkTheme ] = useState(initialDarkTheme);

    useEffect(()=>{
        darkTheme 
            ? document.body.setAttribute('data-pc-theme', 'dark')
            : document.body.setAttribute('data-pc-theme', 'light')

        hlp._localSet('theme', darkTheme)
    }, [darkTheme])


    return (
        <ThemeContext.Provider value={{darkTheme,setDarkTheme}}>
            {children}
        </ThemeContext.Provider>
    )
}